export async function rolesUpdateUseCase(role_id, data, roleRepository) {
    const result = await roleRepository.update(role_id, data);
    
    const role = await new roleRepository.model(result.data.success.arguments);

    if (!role.isValid()) {
        throw new Error("rol inválido");
    }

    return result;
}